import { dpViewType_MultivarAndValuesList, dpViewType_MultivarList } from './types.js';
import { md5 } from '@nu-art/ts-common';
export const noConnectedViewDPView = Object.freeze({
    label: 'Multivars with no connected views',
    _id: 'misc-dp-view',
    type: 'multivar-list',
    enforcedTags: [],
    filter: { tagIds: {} },
    __created: 0,
    __updated: 0,
});
export const cleanDPView = Object.freeze({
    label: '',
    type: 'multivar-list',
    enforcedTags: [],
    filter: { tagIds: {} },
});
export const key_DiseaseViews = 'Disease Views';
const defaultVPName_Complaints = 'Complaints';
const defaultVPName_Exam = 'Exam';
const defaultVPName_DifferentialDiagnosis = 'Differential Diagnosis';
const defaultVPName_Administrative = 'Administrative';
const defaultVPName_RiskFactors = 'Risk Factors';
const defaultVPName_VitalSigns = 'Vital Signs';
const defaultVPName_EKG = 'EKG';
const defaultVPName_Complications = 'Complications';
const defaultVPName_Laboratory = 'Laboratory';
export const defaultVPName_Imaging = 'Imaging';
const defaultVPName_Treatments = 'Treatments';
const defaultVPName_Procedures = 'Procedures';
const defaultVPName_PrecipitatingFactors = 'Precipitating Factors';
const defaultVPName_RelievingFactors = 'Relieving Factors';
const DP_ViewConfig__Complaints = {
    _id: md5(defaultVPName_Complaints),
    label: defaultVPName_Complaints,
    type: dpViewType_MultivarAndValuesList,
    enforcedTags: [],
    filter: { tagIds: { whitelist: ['complaints'] } }
};
const DP_ViewConfig__Exam = {
    _id: md5(defaultVPName_Exam),
    label: defaultVPName_Exam,
    type: dpViewType_MultivarAndValuesList,
    enforcedTags: [],
    filter: { tagIds: { whitelist: ['exam'] } }
};
const DP_ViewConfig__VitalSigns = {
    _id: md5(defaultVPName_VitalSigns),
    label: defaultVPName_VitalSigns,
    type: dpViewType_MultivarAndValuesList,
    enforcedTags: [],
    filter: { tagIds: { whitelist: ['vital signs'] } }
};
const DP_ViewConfig__EKG = {
    _id: md5(defaultVPName_EKG),
    label: defaultVPName_EKG,
    type: dpViewType_MultivarAndValuesList,
    enforcedTags: [],
    filter: { tagIds: { whitelist: ['ekg'] } }
};
const DP_ViewConfig__Complications = {
    _id: md5(defaultVPName_Complications),
    label: defaultVPName_Complications,
    type: dpViewType_MultivarAndValuesList,
    enforcedTags: [],
    filter: { tagIds: { whitelist: ['diseases'] } }
};
const DP_ViewConfig__Laboratory = {
    _id: md5(defaultVPName_Laboratory),
    label: defaultVPName_Laboratory,
    type: dpViewType_MultivarAndValuesList,
    enforcedTags: [],
    filter: { tagIds: { whitelist: ['laboratory'] } }
};
const DP_ViewConfig__Imaging = {
    _id: md5(defaultVPName_Imaging),
    label: defaultVPName_Imaging,
    type: dpViewType_MultivarAndValuesList,
    enforcedTags: [],
    filter: { tagIds: { whitelist: ['imaging'] } }
};
const DP_ViewConfig__Administrative = {
    _id: md5(defaultVPName_Administrative),
    label: defaultVPName_Administrative,
    type: dpViewType_MultivarAndValuesList,
    enforcedTags: [],
    filter: { tagIds: { whitelist: ['administrative'] } }
};
const DP_ViewConfig__RiskFactors = {
    _id: md5(defaultVPName_RiskFactors),
    label: defaultVPName_RiskFactors,
    type: dpViewType_MultivarAndValuesList,
    enforcedTags: [],
    filter: { tagIds: { whitelist: ['history', 'diseases', 'therapy', 'procedure'] } }
};
const DP_ViewConfig__DifferentialDiagnosis = {
    _id: md5(defaultVPName_DifferentialDiagnosis),
    label: defaultVPName_DifferentialDiagnosis,
    type: dpViewType_MultivarList,
    enforcedTags: [],
    filter: { tagIds: { whitelist: ['diseases'] } }
};
const DP_ViewConfig__Treatments = {
    _id: md5(defaultVPName_Treatments),
    label: defaultVPName_Treatments,
    type: dpViewType_MultivarList,
    enforcedTags: [],
    filter: { tagIds: { whitelist: ['therapy'] } }
};
const DP_ViewConfig__Procedures = {
    _id: md5(defaultVPName_Procedures),
    label: defaultVPName_Procedures,
    type: dpViewType_MultivarList,
    enforcedTags: [],
    filter: { tagIds: { whitelist: ['procedure'] } }
};
const DP_ViewConfig__PrecipitatingFactors = {
    _id: md5(defaultVPName_PrecipitatingFactors),
    label: defaultVPName_PrecipitatingFactors,
    type: dpViewType_MultivarAndValuesList,
    enforcedTags: [],
    filter: { tagIds: {} }
};
const DP_ViewConfig__RelievingFactors = {
    _id: md5(defaultVPName_RelievingFactors),
    label: defaultVPName_RelievingFactors,
    type: dpViewType_MultivarAndValuesList,
    enforcedTags: [],
    filter: { tagIds: {} }
};
export const default_DPViewConfigs = [
    DP_ViewConfig__Administrative,
    DP_ViewConfig__Complaints,
    DP_ViewConfig__Exam,
    DP_ViewConfig__VitalSigns,
    DP_ViewConfig__EKG,
    DP_ViewConfig__Complications,
    DP_ViewConfig__RiskFactors,
    DP_ViewConfig__Laboratory,
    DP_ViewConfig__Imaging,
    DP_ViewConfig__DifferentialDiagnosis,
    DP_ViewConfig__Treatments,
    DP_ViewConfig__Procedures,
    DP_ViewConfig__PrecipitatingFactors,
    DP_ViewConfig__RelievingFactors
];
//# sourceMappingURL=consts.js.map